import React from "react";
import "./CollegeFormModal.scss";

import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import Input from "../Inputs/Input";
import CustomSelect from "../Inputs/CustomSelect";
import AlertPopUp from "../../generalComponents/AlertPopUp";
import { cities } from "../../../helper/citiesInputCheck";
import { images } from "../../../constants";
import LoaderDots from "../../generalComponents/LoaderDots";
import { useDispatch, useSelector } from "react-redux";
import {
  removeCollegefromUpdating,
  updateCollege,
} from "../../../actions/college";
import { closeModal } from "../../../actions/ui";
const CollegeFormModal = () => {
  const { collegeToUpdate } = useSelector((state) => state.colleges);
  const { msgAlert } = useSelector((state) => state.alert);
  const { loading } = useSelector((state) => state.ui);

  const dispatch = useDispatch();

  const initialValues = {
    // <-este tambien puede ser el objeto que llega pero funciona como reset
    name: "",
    location: [{ city: "" }],
    specialty: [
      {
        name: "",
      },
    ],
    status: "",
  };

  const formValues = collegeToUpdate || initialValues;

  const collegeSchema = Yup.object().shape({
    name: Yup.string().required("Name is Required"),
    location: Yup.array().min(1, "At least one location is required"),
    specialty: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required("Specialty required"),
      })
    ),
  });

  const handleFormikSubmit = (values) => {
    dispatch(updateCollege(values));

    setTimeout(() => {
      dispatch(removeCollegefromUpdating());
      dispatch(closeModal());
    }, [1000]);
  };
  return (
    <div>
      <Formik
        initialValues={formValues || initialValues}
        validationSchema={collegeSchema}
        onSubmit={handleFormikSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue, errors }) => {
          const value = values.location[0];
    

          return (
            <div className="form-modal__wrapper">
              <div className="form-modal-container">
                <Form>
                  <Input name="name" label="Name:" isModal={true} />

                  <div className="section-modal-cities-select">
                    <label htmlFor="location" className="title-gray-black-18">
                      Location:
                    </label>
                    <CustomSelect
                      className={`custom-modal-select`}
                      value={value}
                      options={cities}
                      onChange={(value) => setFieldValue("location", value)}
                      editingEvent={true}
                      editingOptions={formValues.location} //<- aca van los valores que llegan
                    />
                    <div className="error-message-form">
                      <ErrorMessage name="location" />
                    </div>
                  </div>

                  <div className="section-modal-array-input">
                    <FieldArray name="specialty">
                      {({ remove, push }) => (
                        <div className="field-array">
                          <div className="field-array__heading">
                            <label className="field-array__heading--label title-gray-black-18">
                              Specialty:
                            </label>

                            <button
                              className="field-array-modal__heading--add-btn btn-primary"
                              type="button"
                              onClick={() => push("")}
                            >
                              + add
                            </button>
                          </div>

                          {values.specialty.length > 0 &&
                            values.specialty.map((sp, index) => (
                              <div className="field-array__input" key={index}>
                                <div className="input-modal__container">
                                  <Field
                                    type="text"
                                    name={`specialty.${index}.name`}
                                    className="field-array-modal__input--item"
                                  />

                                  <button
                                    type="button"
                                    className="field-array__input--remove-btn"
                                    onClick={() => remove(index)}
                                  >
                                    <img src={images.IconRemove} alt="" />
                                  </button>
                                </div>

                                <div className="error-message-form">
                                  <ErrorMessage
                                    name={`specialty.${index}.name`}
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  <div className="form-container__button-send">
                    {loading ? (
                      <LoaderDots />
                    ) : (
                      <button className="btn-save" type="submit">
                        Update College
                      </button>
                    )}
                  </div>
                </Form>
              </div>

              <div className="alert-container">
                {msgAlert && (
                  <AlertPopUp msg={`${msgAlert.msg}`} type={msgAlert.type} />
                )}
              </div>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default CollegeFormModal;
